import { useState, FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import './LoginPage.css'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const { signIn, user } = useAuth()
  const navigate = useNavigate()

  // If already logged in, redirect
  if (user) {
    navigate('/admin', { replace: true })
    return null
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    const { error: err } = await signIn(email, password)
    if (err) {
      setError(err)
      setLoading(false)
    } else {
      navigate('/admin', { replace: true })
    }
  }

  return (
    <div className="login-page">
      <div className="login-card animate-scale-in">
        <div className="login-logo">
          <span className="login-logo-icon">M</span>
          <h1 className="login-logo-text">Medi-Lane</h1>
        </div>
        <p className="login-subtitle">Admin-Bereich</p>

        <form className="login-form" onSubmit={handleSubmit}>
          {error && (
            <div className="login-error animate-shake">
              <span>⚠️</span> {error}
            </div>
          )}

          <div className="login-field">
            <label htmlFor="login-email">E-Mail</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@medi-lane.de"
              required
              autoComplete="email"
              autoFocus
            />
          </div>

          <div className="login-field">
            <label htmlFor="login-password">Passwort</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <span className="login-button-loading">
                <span className="loading-spinner-small" />
                Anmeldung...
              </span>
            ) : (
              'Anmelden'
            )}
          </button>
        </form>

        <p className="login-footer">
          🔒 Zugang nur für autorisierte Mitarbeiter
        </p>
      </div>
    </div>
  )
}
